
/**
 * Mutation types for Session store
 */
export const SET_USER	= 'SET_SESSION_USER';
